import Element from "config/routes/Element";
import RedirectToRoute from "config/routes/RedirectToRoute";
import { lazy } from "react";
import { Route, useParams } from "react-router-dom";
import UserAccess from "views/Collaborators/components/UserAccess";
import UserForm from "views/Collaborators/components/UserForm";
import { LEGACY_EDIT_ACESS_PATH, USER_ROUTES as ROUTES } from "./utils/userRoutes";

const UsersList = lazy(() => import("views/Collaborators"));
const AddUser = lazy(() => import("views/Collaborators/components/AddUser"));
const EditUser = lazy(() => import("views/Collaborators/components/EditUser"));

function EditUserInfoTab() {
  const { userId } = useParams();
  return <UserForm userId={userId} />;
}

function EditUserAccessTab() {
  const { userId } = useParams();
  return <UserAccess userId={userId} />;
}

export const usersRoutes = (
  <Route path={ROUTES.users}>
    <Route
      index
      element={
        <Element requiredPermission="displayUsers">
          <UsersList />
        </Element>
      }
    />

    <Route
      path={ROUTES.add}
      element={
        <Element requiredPermission="createUsers">
          <AddUser />
        </Element>
      }
    />

    <Route
      path={ROUTES.userDetail}
      element={
        <Element requiredPermission="updateUsers">
          <EditUser />
        </Element>
      }
    >
      <Route index element={<RedirectToRoute route={ROUTES.editInfo} />} />
      <Route path={ROUTES.edit} element={<RedirectToRoute route={ROUTES.editInfo} />} />
      <Route path={ROUTES.editInfo} element={<EditUserInfoTab />} />
      <Route path={ROUTES.editAccess} element={<EditUserAccessTab />} />
      <Route
        path={LEGACY_EDIT_ACESS_PATH}
        element={<RedirectToRoute route={ROUTES.editAccess} />}
      />
      <Route path="*" element={<RedirectToRoute route={ROUTES.editInfo} />} />
    </Route>
  </Route>
);
